import { useTranslation } from "react-i18next";
import {
  BreakfastTime,
  LunchTime,
  DinnerTime,
  AfternoonSnackTime,
  EveningSnackTime,
} from "@utils/defaultImages";

const DietOverviewTabs = ({
  currentTimeTab,
  tab,
  isCurrentMealTime,
  handleCategoryChange,
  handleTypeChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Category Tabs */}
      <div className="flex justify-center my-[10px]">
        <div className="flex bg-white rounded-full p-1 border border-[#E9E9E9]">
          {["meals", "snacks"].map((mealCat) => {
            const isActive = tab.category === mealCat;
            // Check if this category is the current time category
            const isCurrentTimeCategory = currentTimeTab.category === mealCat;

            return (
              <button
                key={mealCat}
                onClick={() => handleCategoryChange(mealCat)}
                className={`relative flex-1 px-6 py-2 text-sm rounded-full capitalize transition-all duration-300 min-w-[120px] text-center ${
                  isActive
                    ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                    : "bg-white text-black"
                }`}
              >
                <span className="flex items-center justify-center gap-2 relative">
                  {mealCat === "meals"
                    ? t("dietPlanDashboard.mealListing.mealTabName")
                    : t("dietPlanDashboard.mealListing.snacksTabName")}
                  {/* Show green dot if this is the current time category */}
                  {isCurrentTimeCategory && (
                    <span className="relative flex h-2.5 w-2.5">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Meal Type Buttons */}
      {tab.category === "meals" ? (
        <div className="grid grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-2 xl:gap-8 my-[10px]">
          {["breakfast", "lunch", "dinner"].map((mealType) => (
            <button
              key={mealType}
              onClick={() => handleTypeChange(mealType)}
              className={`px-2 py-2 text-[12px] lg:text-[12px] xl:text-[14px] rounded-md capitalize relative ${
                tab.type === mealType
                  ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                  : "bg-white text-black border border-[2px] border-[#F2F2F2B8] hover:border-[#0575e6] hover:text-[#0575e6]"
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                {mealType === "breakfast" ? (
                  <BreakfastTime className="min-w-5 min-h-5" />
                ) : mealType === "dinner" ? (
                  <DinnerTime className="min-w-5 min-h-5" />
                ) : (
                  <LunchTime className="min-w-5 min-h-5" />
                )}
                {t(
                  `dietPlanDashboard.mealListing.Meals.${mealType.toLowerCase()}`
                )}
                {/* Show green dot if this is the current time type */}
                {currentTimeTab.category === "meals" &&
                  currentTimeTab.type === mealType && (
                    <span className="relative flex h-3 w-3">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                    </span>
                  )}
              </span>
            </button>
          ))}
        </div>
      ) : (
        <div className="flex justify-center gap-4 lg:gap-2 xl:gap-4 my-[10px]">
          {["afternoon", "evening"].map((snackType) => (
            <button
              key={snackType}
              onClick={() => handleTypeChange(snackType)}
              className={`w-[35%] px-4 py-2 text-[14px] lg:text-[12px] xl:text-[14px] rounded-md capitalize relative ${
                tab.type === snackType
                  ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                  : "bg-white text-black border border-[2px] border-[#F2F2F2B8] hover:border-[#0575e6] hover:text-[#0575e6]"
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                {snackType === "afternoon" ? (
                  <AfternoonSnackTime />
                ) : (
                  <EveningSnackTime />
                )}
                {t(`dietPlanDashboard.mealListing.Snacks.${snackType}`)}
                {/* Show green dot if this is the current time type */}
                {currentTimeTab.category === "snacks" &&
                  currentTimeTab.type === snackType && (
                    <span className="relative flex h-3 w-3">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                    </span>
                  )}
              </span>
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default DietOverviewTabs;
